var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _controller, _handleProductSelect, _handleZoomMediaSelected;
import { Component } from "@theme/component";
import { ThemeEvents, ZoomMediaSelectedEvent } from "@theme/events";
import { StandardEvents, ProductSelectEvent } from "@shopify/events";
class MediaGallery extends Component {
  constructor() {
    super(...arguments);
    this.selectionGeneration = 0;
    this.selectionDetached = false;
    this.selectionTarget = null;
    __privateAdd(this, _controller, new AbortController());
    __privateAdd(this, _handleProductSelect, (event) => {
      var _a;
      if (!(event.target instanceof Element) || event.target.closest("product-card")) return;
      if (!event.promise || typeof event.promise.then !== "function" || this.selectionDetached) return;
      if (((_a = event.product) == null ? void 0 : _a.id) && this.dataset.productId && String(event.product.id) !== String(this.dataset.productId)) return;
      const generation = ++this.selectionGeneration;
      return event.promise.then(({ detail }) => {
        if (this.selectionDetached || generation !== this.selectionGeneration) return;
        if (!(detail == null ? void 0 : detail.html)) return;
        const { html } = detail;
        const newMediaGallery = html.querySelector("media-gallery");
        if (!newMediaGallery) return;
        this.replaceWith(newMediaGallery);
      }).catch((error) => {
        if ((error == null ? void 0 : error.name) !== "AbortError") console.warn("[media-gallery] Event promise rejected:", error);
      });
    });
    __privateAdd(this, _handleZoomMediaSelected, async (event) => {
      var _a;
      (_a = this.slideshow) == null ? void 0 : _a.select(event.detail.index, void 0, { animate: false });
    });
  }
  connectedCallback() {
    var _a;
    super.connectedCallback();
    this.selectionDetached = false;
    if (__privateGet(this, _controller).signal.aborted) _controller.set(this, new AbortController());
    const { signal } = __privateGet(this, _controller);
    const target = this.closest(".shopify-section, dialog");
    target == null ? void 0 : target.addEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect), { signal });
    (_a = this.refs.zoomDialogComponent) == null ? void 0 : _a.addEventListener(ThemeEvents.zoomMediaSelected, __privateGet(this, _handleZoomMediaSelected), {
      signal
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.selectionDetached = true;
    ++this.selectionGeneration;
    __privateGet(this, _controller).abort();
  }
  /**
   * Zooms the media gallery.
   *
   * @param {number} index - The index of the media to zoom.
   * @param {PointerEvent} event - The pointer event.
   */
  zoom(index, event) {
    var _a;
    (_a = this.refs.zoomDialogComponent) == null ? void 0 : _a.open(index, event);
  }
  /**
   * Preloads an image.
   * @param {number} index - The index of the media to preload.
   */
  preloadImage(index) {
    var _a, _b;
    const zoomDialogMedia = (_a = this.refs.zoomDialogComponent) == null ? void 0 : _a.refs.media[index];
    if (!zoomDialogMedia) return;
    (_b = this.refs.zoomDialogComponent) == null ? void 0 : _b.loadHighResolutionImage(zoomDialogMedia);
  }
  get slideshow() {
    return this.refs.slideshow;
  }
  get media() {
    return this.refs.media;
  }
  get presentation() {
    return this.dataset.presentation;
  }
}
_controller = /* @__PURE__ */ new WeakMap();
_handleProductSelect = /* @__PURE__ */ new WeakMap();
_handleZoomMediaSelected = /* @__PURE__ */ new WeakMap();
if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}
export {
  MediaGallery
};
